import React from "react";
import Label from "../FormComponents/Label";
import Input from "../FormComponents/Input";
// import CustomCss from "../BuilderComponents/CustomCss";

const EditSeparator = ({ editElementData, setEditElementData }) => {
  const handleChange = (event) => {
    const { name, value } = event.target;
    setEditElementData({
      ...editElementData,
      [name]: name === "separator_width" ? Number(value) : value
    });
  };
  return (
    <div className="builder_form">
      <Label>Separator Direction</Label>
      <select
        value={editElementData.direction || "horizontal"}
        name="direction"
        onChange={handleChange}
        className="builder_input"
      >
        <option value="horizontal">Horizontal</option>
        <option value="vertical">Vertical</option>
      </select>
      <Label>Separator Width (in px)</Label>
      <Input
        type="number"
        name="separator_width"
        value={editElementData.separator_width}
        onChange={handleChange}
        placeholder="Enter width in px"
        className="builder_input w_80"
      />
    </div>
  );
};

export default EditSeparator;
